import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ImageGalleryComponent from '../images/ImageGalleryComponent';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { obtenerMuestroTarifaTipoHab } from '../../services/motorService';
import { obtenerFotosTipoHab, obtenerDatosHotel } from '../../services/motorService';
import Cookies from 'js-cookie';

export default function ResponsiveDialog({ open, handleClose, ratePlan, selectedRange, room }) {
  const [nightlyRates, setNightlyRates] = React.useState([]);
  const [images, setImages] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const hotCod = Cookies.get('hotCod');
  const [rateCoin, setRateCoin] = useState('');
  const [datosHotel, setDatosHotel] = useState({});
  
  React.useEffect(() => {
      const getData = async () => {
        try {
          const data = await obtenerDatosHotel(hotCod);
          setDatosHotel(data);
        } catch (error) {
          console.error('Error fetching hotel data:', error);
        }
      };
      getData();
    }, []); // Lista de dependencias vacía para que se ejecute solo una vez
  React.useEffect(() => {
    if (ratePlan && selectedRange) {
      fetchNightlyRates(ratePlan.ratePlan?.TarifaTipoHab, selectedRange);
      setRateCoin(ratePlan.ratePlan?.TarifaMonDsc);
    }
    const fetchImages = async () => {
      if (ratePlan) {
        const tipoHabitacion = ratePlan.ratePlan?.TarifaTipoHab;
        const fotos = await obtenerFotosTipoHab(hotCod, tipoHabitacion); 
        if (fotos && Array.isArray(fotos) && fotos.length > 0) {
          const formattedImages = fotos.map(foto => ({
            original: `data:image/png;base64,${foto.TipoHabFoto}`,
            thumbnail: `data:image/png;base64,${foto.TipoHabFoto}`
          }));
          setImages(formattedImages);
        } else {
          if (room) {
            setImages([{
              original: room?.image 
                ? `data:image/png;base64,${room.image}`
                : "https://via.placeholder.com/1000x600",
              thumbnail: room?.image 
                ? `data:image/png;base64,${room.image}`
                : "https://via.placeholder.com/1000x600"
            }]);
          }
        }
      }
    };

    if (open) {
      fetchImages();
    } else {
      setImages([]);  // Limpiar las imágenes cuando se cierra el diálogo
    }

  }, [ratePlan, selectedRange, open, room]);

  const fetchNightlyRates = async (tipoHab, selectedRange) => {
    try {
      const startDate = new Date(selectedRange.startDate);
      const endDate = new Date(selectedRange.endDate);

      const nightlyRates = [];

      let currentDate = new Date(startDate);
      while (currentDate < endDate) { 
        const formattedDate = currentDate.toISOString().split('T')[0];
        const rate = ratePlan.ratePlan?.TarifaPrecioDesde;
        const coin = ratePlan.ratePlan?.TarifaMonDsc;
        console.log('rate', rate);
        nightlyRates.push({ date: formattedDate, rate, coin });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setNightlyRates(nightlyRates);
    } catch (error) {
      console.error('Error fetching nightly rates:', error);
    }
  };

  const formatDate = (date) => {
    const parsedDate = new Date(date); 
    const day = parsedDate.getUTCDate();
    const month = parsedDate.getUTCMonth() + 1;
    const year = parsedDate.getUTCFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }
  const totalAmount = nightlyRates.reduce((total, rate) => total + parseFloat(rate.rate), 0).toFixed(2);


  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth="md" 
      fullWidth
      PaperProps={{
        style: {
          maxHeight: fullScreen ? '100%' : '80vh', 
          maxWidth: fullScreen ? '100%' : '45vw',
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {ratePlan?.TarifaDescripcion}
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <ImageGalleryComponent images={images} />
        </DialogContent>
        <DialogContent>
          <DialogContentText sx={{ fontWeight: 'bold' }}>
            Políticas de cancelación
          </DialogContentText>
          <DialogContentText>
            {datosHotel.MotorHotNormas || 'No hay políticas de cancelación disponibles.'}
          </DialogContentText>
        </DialogContent>
        <DialogContent>
          <DialogContentText sx={{ fontWeight: 'bold' }}>
            Desglose de la tarifa desde {formatDate(new Date(selectedRange.startDate))} hasta {formatDate(new Date(selectedRange.endDate))}
          </DialogContentText>
          {
            nightlyRates && nightlyRates.map((nightlyRate, index) => (
              <Grid container key={index}>
                <Grid item xs={6}>
                  <DialogContentText>
                    {formatDate(nightlyRate.date)} 
                  </DialogContentText>
                </Grid>
                <Grid item xs={6}>
                  <DialogContentText sx={{ textAlign: 'right' }}>
                    {` ${nightlyRate.coin} ${parseFloat(nightlyRate.rate).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                  </DialogContentText>
                </Grid>
                <Grid item xs={12}>
                </Grid>
              </Grid>
            ))
          }
          <Divider sx={{ marginTop: 2 }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
            <DialogContentText sx={{ fontWeight: 'bold' }}>
              Total
            </DialogContentText>
            <DialogContentText sx={{ fontWeight: 'bold', textAlign: 'right' }}>
              {`${rateCoin} ${parseFloat(totalAmount).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            </DialogContentText>
          </Box>
        </DialogContent>
      </DialogContent>
    </Dialog>
  );
}